import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchInterceptors } from "../../Api/fetchInterceptors";

const END_POINT_PASSWORD_CHANGE =
  process.env.REACT_APP_END_POINT_PASSWORD_CHANGE?.replace(/"/g, "");

export const change_Password_Api = createAsyncThunk(
  "change/password",
  async (patchData, thunkApi) => {
    try {
      const result = fetchInterceptors(END_POINT_PASSWORD_CHANGE, "POST");
      return result;
    } catch (error) {
      console.log(error);
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const change_Password_Slice = createSlice({
  name: "changePassword",
  initialState: {
    response: null,
    success: false,
    statusCode: null,
    error: null,
    loading: null,
  },
  reducers: {
    setDefault_Change_Api_Key: (state) => {
      state.response = null;
      state.success = false;
      state.statusCode = null;
      state.error = null;
      state.loading = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(change_Password_Api.pending, (state) => {
        state.loading = true;
      })
      .addCase(change_Password_Api.fulfilled, (state, action) => {
        if (action.payload?.success) {
          state.error = null;
          state.response = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        } else {
          state.response = null;
          state.error = action.payload;
          state.success = action.payload?.success;
          state.statusCode = action.payload?.code;
          state.loading = false;
        }
      })
      .addCase(change_Password_Api.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setDefault_Change_Api_Key } = change_Password_Slice.actions;

export default change_Password_Slice.reducer;
